import { LoaderFunction, useLoaderData } from "react-router-dom";

import { CheckoutSuccessContainer } from "@/modules/checkout";
import { get } from "api";
import { queryClient } from "pages/Root";
import { waitObj } from "toolbox/Promise";

const load = async () => {
  const rewards = queryClient.fetchQuery(["/rewards"], () =>
    get("/rewards", {})
  );
  const platform = queryClient.fetchQuery(["/platform"], () =>
    get("/platform")
  );
  return waitObj({ rewards, platform });
};

type LoaderData = Awaited<ReturnType<typeof load>>;

export const CheckoutSuccessPageLoader: LoaderFunction = () => {
  return load();
};

const CheckoutSuccessPage = () => {
  const { rewards, platform } = useLoaderData() as LoaderData;

  return (
    <CheckoutSuccessContainer
      rewards={rewards}
      platform={platform}
      errorCta={{ text: "Back to cart", link: "/cart" }}
    />
  );
};

export default CheckoutSuccessPage;
